/**
 * SurebetViewTimeWindowFilter - Kickoff time presets for arbitrage view filters.
 * Presets: all | today | next24h | next48h (client local timezone).
 */

import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useSurebet } from '../context/SurebetContext';
import { useTranslation } from '../../i18n/hooks';
import { TIME_WINDOW_VALUES } from '../viewFilters/surebetViewFilters';
import '../../bestOdds/components/BestOddsFilterBar.css';

const TIME_WINDOW_LABEL_KEYS = {
  all: 'surebets.viewFilters.timeWindowAll',
  today: 'surebets.viewFilters.timeWindowToday',
  next24h: 'surebets.viewFilters.timeWindowNext24h',
  next48h: 'surebets.viewFilters.timeWindowNext48h'
};

const SurebetViewTimeWindowFilter = ({ className = '' }) => {
  const { t } = useTranslation();
  const { viewFilters, setTimeWindow } = useSurebet();

  const activeWindow = TIME_WINDOW_VALUES.includes(viewFilters?.timeWindow)
    ? viewFilters.timeWindow
    : 'all';

  const handleSelect = useCallback((value) => {
    setTimeWindow(value);
  }, [setTimeWindow]);

  return (
    <div
      className={`best-odds-filter-bar__chip-row ${className}`.trim()}
      role="group"
      aria-label={t('surebets.viewFilters.timeWindowAriaLabel')}
    >
      <span className="best-odds-filter-bar__chip-row-label" id="surebet-time-window-label">
        {t('surebets.viewFilters.timeWindowLabel')}
      </span>
      <div
        className="best-odds-filter-bar__chip-row-chips"
        role="group"
        aria-labelledby="surebet-time-window-label"
      >
        {TIME_WINDOW_VALUES.map((value) => {
          const isActive = activeWindow === value;
          const label = t(TIME_WINDOW_LABEL_KEYS[value]);
          const ariaLabel = value === 'all'
            ? t('surebets.viewFilters.timeWindowAllAriaLabel')
            : label;

          return (
            <button
              key={value}
              type="button"
              className={`best-odds-filter-bar__chip${isActive ? ' is-active' : ''}`}
              aria-pressed={isActive}
              aria-label={ariaLabel}
              onClick={() => handleSelect(value)}
            >
              {label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

SurebetViewTimeWindowFilter.propTypes = {
  className: PropTypes.string
};

export default SurebetViewTimeWindowFilter;
